export default __webpack_public_path__ + "static/media/OurDelight_1.9393001f.png";